module.exports = __webpack_public_path__ + "img/erweima2.cb4ed4f6.png";